import React, { Component } from 'react';
import { Button } from 'antd';
import SiteTemplate from '../../common/siteTemplate';
import SideNav from '../SideNav';

class SiteForm extends Component {
    state = {
        edit: false,
    }

    leave = () => {
        window.history.go(-1);
    }

    edit = () => {
        this.setState(prevState => ({
            edit: !prevState.edit,
        }));
    }
    
    render() {
        const { hospitalName } = sessionStorage;
        const { edit } = this.state;
        return (
            <div className="content site_start">
                <SideNav selectKey='siteStart'/>
                <div className="main">
                    <div style={{ overflow: 'hidden' }}>
                        <div style={{ float: 'left' }}>
                            <i
                                className="icon iconfont"
                                style={{ marginRight: 4, fontSize: '20px', color: '#1296DB'}}
                            >&#xe65b;</i>
                            {hospitalName}
                        </div>
                        <div style={{ float: 'right', right: 60, position:"relative" }}>
                                 <Button
                                key="edit"
                                type="primary"
                                onClick={this.edit}
                                disabled={edit}
                            >编辑</Button>
                        </div>
                        <div style={{ float: 'right', right: -60, position:"relative" , color: '#1296DB', cursor: 'pointer' }} onClick={this.leave}>
                            <i
                                className="icon iconfont"
                                style={{ marginRight: 4, fontSize: '20px' }}
                            >&#xe63d;</i>
                            返回
                        </div>
                    </div>
                    <div style={{ marginTop: 10 }}>
                        <SiteTemplate edit={edit} changeEdit={this.edit} ssuModuleStructureId={10} />
                    </div>
                </div>  
            </div>
        );
    }
}

export default SiteForm;


// WEBPACK FOOTER //
// ./src/components/invStartUp/siteForm/index.js